export enum UnitDashboardKeys
{
    DETAILS,
    COMMUNICATIONS,
    DOCUMENTS,
    REQUESTS,
    VIOLATIONS,
}
